

const getters = {
  userCameFromAnyRoute: (state) => !_.isEmpty(state.fromRoute),

  anyError: (state) => !_.isEmpty(state.formError),

  sapPromoCodes: (state) => state.sapPromoCodes
}

export default getters



// WEBPACK FOOTER //
// ./client/store/getters.js